import createMuiTheme from '@material-ui/core/styles/createTheme';

const colors = {
    darkBlue: {
        light: '#4b5ca2',
        main: '#1E69D2',
        dark: '#000d47',
        contrastText: '#fff'
    },
    purple: {
        light: '#dd76ae',
        main: '#a9467f',
        dark: '#771253',
        contrastText: '#fff'
    },
    green: '#01A890',
    black: '#000',
    gray: '#757575',
    white: '#fff'
};

export default createMuiTheme({
    palette: {
        type: 'light',
        primary: {...colors.darkBlue},
        secondary: {...colors.purple},
        text: {
            primary: colors.black,
            secondary: colors.gray
        },

    },
    overrides: {}
});
